import { applyMiddleware, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';

import ACRApp from 'src/redux/reducers';
import rootSaga from 'src/redux/sagas';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();

const persistedReducer = persistReducer(persistConfig, ACRApp);

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware)),
);

export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export default store;

export type RootState = ReturnType<typeof ACRApp>;
